"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProvider = void 0;
const algoliasearch_1 = require("algoliasearch");
const react_1 = __importDefault(require("react"));
const react_instantsearch_1 = require("react-instantsearch");
const client_common_1 = require("@algolia/client-common");
const index_1 = require("../constants/index");
/**
 * A component that provides the search context to its children by integrating with Algolia's search client.
 * It initializes the Algolia search client with the provided appId and apiKey, then passes it to the InstantSearchCore component.
 *
 * @param {Object} props - The properties for the SearchProvider component.
 * @param {React.ReactNode} props.children - The child components to be rendered inside the provider.
 * @param {string} props.appId - The Algolia application ID used for authentication.
 * @param {string} props.apiKey - The Algolia API key used for authentication.
 * @param {...Object} props.rest - Any other props passed to the InstantSearchCore component.
 * @returns {React.Element} The rendered SearchProvider component, with the search context passed to children.
 */
function SearchProvider(props) {
    const { children, appId, apiKey, caching, routing: routingProps, ...rest } = props;
    const routing = routingProps ?? true;
    // Only add cache options if caching is enabled
    const searchClient = react_1.default.useMemo(() => {
        const clientOptions = caching
            ? {
                requestsCache: (0, client_common_1.createBrowserLocalStorageCache)({
                    key: 'algolia-requests',
                    timeToLive: index_1.CACHE_TTL,
                }),
                responsesCache: (0, client_common_1.createBrowserLocalStorageCache)({
                    key: 'algolia-responses',
                    timeToLive: index_1.CACHE_TTL,
                }),
            }
            : {};
        return (0, algoliasearch_1.algoliasearch)(appId, apiKey, clientOptions);
    }, [appId, apiKey, caching]);
    return (react_1.default.createElement(react_instantsearch_1.InstantSearch, { ...rest, searchClient: searchClient, routing: routing }, children));
}
exports.SearchProvider = SearchProvider;
